
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admission-consultation",
      function () {
        return require("private-next-pages/admission-consultation/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admission-consultation"])
      });
    }
  